import MaterialIcon from '@/components/atom/MaterialIcon';
import { DOCTOR_FILTER_OPTIONS, EDoctorFilterType } from '@/models/diagnosis/doctor-filter';
import { NonF2fDoctor } from '@/models/doctor/telemedicine';
import theme from '@/styles/theme';
import { cn } from '@/utils/style';

interface Props {
  doctor: NonF2fDoctor;
  cheapestPrice?: number;
  selectedFilters?: EDoctorFilterType[];
}
const getFilterLabel = (filterType: EDoctorFilterType, professionalDepartmentName?: string | null): string => {
  if (filterType === EDoctorFilterType.SPECIALIST && professionalDepartmentName) {
    return `${professionalDepartmentName}전문의`;
  }

  const filterOption = DOCTOR_FILTER_OPTIONS.find((option) => option.type === filterType);
  if (!filterOption) {
    return '';
  }

  return filterOption.label.replace(/\s+/g, '');
};

const TelemedicineDoctorItem = (props: Props) => {
  const { doctor, selectedFilters } = props;
  const shouldShowReview = doctor?.review.isReviewAverageRatingOverZero;

  const filterTags =
    selectedFilters
      ?.filter((filterType) => {
        if (filterType === EDoctorFilterType.SPECIALIST) {
          return !!doctor.professionalDepartmentName;
        }
        return true;
      })
      .map((filterType) => ({
        type: filterType,
        label: getFilterLabel(filterType, doctor.professionalDepartmentName),
      }))
      .filter((tag) => tag.label) || [];

  return (
    <div className={'relative flex items-center justify-between pr-[16px] pl-[24px]'}>
      <div className={'flex w-full flex-col gap-[12px] pt-[20px] pb-[24px]'}>
        <div className={'flex flex-col gap-[2px]'}>
          <h2 className={'typography-ui-13r text-gray-400'}>{doctor.hospitalName}</h2>
          <div className={'flex items-center gap-[8px]'}>
            <h3 className={'typography-ui-19sb text-gray-900'}>{doctor.doctorNameFullText}</h3>
            {shouldShowReview && (
              <div className={'flex items-center'}>
                <MaterialIcon name={'star'} color={theme.color.yellow500} size={16} filled />
                <span className={'typography-ui-13m text-gray-700'}>{doctor.review.reviewAverageText}</span>
                <span className={'typography-ui-13r text-gray-400'}>({doctor.review.reviewCountText})</span>
              </div>
            )}
          </div>
        </div>
        {filterTags.length > 0 && (
          <div className={'flex flex-wrap items-center gap-[4px]'}>
            {filterTags.map((tag) => (
              <div
                key={tag.type}
                className='flex h-[20px] items-center gap-[2px] rounded-[4px] bg-green-100 px-[4px] py-[1px]'
              >
                <MaterialIcon name='check' size={14} color={theme.color.green800} />
                <span className='typography-ui-12m text-green-800'>{tag.label}</span>
              </div>
            ))}
          </div>
        )}
        {doctor.medicinePricing && (
          <p className={'typography-ui-20sb text-gray-900'}>{doctor.medicinePricing.medicinePriceDisplayPrice}원</p>
        )}
      </div>
      <div className={'relative pb-[8px]'}>
        {doctor.profileUrl && (
          <>
            <img
              className={'aspect-square h-[120px] w-[120px]'}
              src={doctor.profileUrl}
              alt={`${doctor.doctorName} 의사 사진`}
            />
            <div
              className={cn([
                'absolute right-0 bottom-[8px] left-0 h-[32px] w-[120px]',
                {
                  'bg-gradient-to-t from-white to-transparent': doctor.profileUrl,
                },
              ])}
            />
          </>
        )}
      </div>
    </div>
  );
};

export default TelemedicineDoctorItem;
